<template>

  <div class="user">


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="user_id" label="总代" width="100" align="center">

              <template #default="{row}">
                {{ row.user && row.user.nickName? row.user.nickName:"" }}
              </template>

            </el-table-column>

            <el-table-column prop="agent_user_id" label="拨出代理"  align="center">

                   <template #default="{row}">
                  {{ row.agentuser &&  row.agentuser.nickName?row.agentuser.nickName:"" }}
                </template>

            </el-table-column>

            <el-table-column prop="deduction_achievement" label="扣除业绩"  align="center">
              <template #default="{row}">
                {{ row.deduction_achievement }}
              </template>
            </el-table-column>

            <el-table-column prop="total_achievement" label="总业绩"  align="center">
              <template #default="{row}">
                <span style="font-weight:bold">{{ row.total_achievement }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="act_achievement" label="实际业绩"  align="center">
              <template #default="{row}">
                <span style="font-weight:bold">{{ row.act_achievement }}</span>
              </template>
            </el-table-column>
            

            <el-table-column prop="award" label="奖励金额"  align="center">
              <template #default="{row}">
                <span style="color:#67C23A">+{{ row.award }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="deduction_award" label="扣除奖励"  align="center">
              <template #default="{row}">
                <span style="color:#F56C6C">-{{ row.deduction_award  }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="act_award" label="实际奖励"  align="center">
              <template #default="{row}">
                <span style="color:#409EFF">{{ row.act_award }}</span>
              </template>
            </el-table-column>

  <el-table-column prop="team_award_remark" label="奖励链条" width="200"  align="center"> </el-table-column>

            

                     <el-table-column prop="act_achievement" label="月份" align="center">
              <template #default="{row}">
                <span style="font-weight:bold">{{ row.month }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="is_settled" label="结算状态"  align="center">
              <template #default="{row}">
                <el-tag :type="row.is_settled==1 ? 'success' : 'warning'" size="small">
                  {{ row.is_settled==1 ? '已结算' : '未结算' }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="settle_time" label="结算时间" width="150" align="center">
              <template #default="{row}">
                {{ row.settle_time || '--' }}
              </template>
            </el-table-column>

         


            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <!-- <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :team_award_log_id="team_award_log_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import Team_award_logApi from '@/api/team_award_log.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        team_award_log_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//团队奖记录标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Team_award_logApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.team_award_log_id = row.team_award_log_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            Team_award_logApi.del(
              {
                team_award_log_id: row.team_award_log_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/team_award_log/index/index.vue